export enum AcademicYearStatus {
  ACTIVE = "ACTIVE",
  COMPLETED = "COMPLETED",
  INACTIVE = "INACTIVE",
}
